import styled from 'styled-components';

const HeaderDesktop = styled.div`
	display: flex;
	align-items: center;
	color: #ffeb00;
	display: flex;
	align-items: center;
	background: ${({ theme }) => theme.backgroundHeader};
	.header-bar {
		margin-top: 0px;
		display: flex;
		justify-content: space-between;
		padding: ${({ theme }) => theme.paddingHeaderDesktop};
		text-align: center;
	}

	.headerLogo {
		filter: ${({ theme }) => theme.filterLogoHeader};
	}
`;

export default HeaderDesktop;
